import React, { Fragment } from "react";
import { getExtensionFile } from "../../../helpers";
function showFileDowload({ data }) {


    let DownloadFile = ({ data }) => {
        return (
            <Fragment>
                <div
                    className={`border-2 border-green-200 rounded-sm p-2
                bg-gradient-to-b from-green-100
                    to-green-200 hover:from-green-200 hover:to-green-100
                `}
                >
                    <h3 className="text-green-500 font-semibold text-sm md:text-base lg:text-2xl">
                        {data.Question}
                    </h3>
                    <div className="flex mt-2 p-1">
                        <h4 className="mb-0 text-sm font-light text-green-900">
                            เปิดอ่านไฟล์&nbsp;
                        </h4>
                        <a
                            href={`${data.ndata}`}
                            rel="noreferrer noopener"
                            className="hover:no-underline"
                            target="_blank"
                        >
                            <h5 className="mb-0 text-sm font-light text-green-900  ">
                                <i className="fas fa-hand-point-right"></i>
                                &nbsp;
                                <span className="hover:font-medium hover:underline">
                                    ดาวน์โหลด
                                </span>
                            </h5>
                            {/* <button className="p-2 bg-custompink-400 underline text-white rounded">
                            {" "}
                            ดาวน์โหลดเอกสาร
                        </button> */}
                        </a>
                    </div>
                </div>
            </Fragment>
        );
    };

    return (
        <div id="tgl1" className="tgl-styl style3">
            {data && <DownloadFile data={data} />}
        </div>
    );
}

export default showFileDowload;
